import React from 'react';
import SubHeader from '../components/styledComponents/SubHeader';
import InlineLink from '../components/styledComponents/InlineLink';

export default () => [
  <SubHeader>About Me</SubHeader>,
  <p>
    Hi, I'm Lee Roberts. I'm the COO of Duckly and a freelance web developer. I
    specialize in Ruby on Rails, JavaScript and React, but enjoy a little Python
    also. I am passionate about TDD, Linux, and OSS. I love writing well-tested
    code and solving unusual coding problems. I'm a programming language fanatic
    and am currently investigating Elixir and Crystal, and reading up on
    functional programming concepts.
  </p>,
  <p>
    I live in Sandy Springs, GA with Ally, my beautiful and brilliant wife who
    loves me in spite of endless hours plastered to a monitor. When I'm not
    coding or blogging, you can find me creating cubist oil paintings, breaking
    a computer trying the latest Linux flavor, or in the great outdoors.
  </p>,
  <p>
    If you have web development needs or have feedback on the blog, you can
    reach me via the&nbsp;
    <InlineLink to="/contact">contact form</InlineLink>.
  </p>,
];



// WEBPACK FOOTER //
// ./src/pages/about.js